function nombreErrores () {
    const errors = []
    if (!this.$v.form.nombre.$dirty) return errors;
    !this.$v.form.nombre.required && errors.push('El nombre es obligatiorio')
    return errors
}

function documentoErrores () {
    const errors = []
    if (!this.$v.form.documento.$dirty) return errors
    !this.$v.form.documento.valid_documento && errors.push((this.form.tipoDocumento ? this.form.tipoDocumento : 'Documento') + ' no válido')
    !this.$v.form.documento.required && errors.push('El ' + this.form.tipoDocumento + ' es obligatorio')
    return errors
}

function telefonoErrores(hola) {
    const errors = []
    if (!this.$v.form.telefono.$dirty) return errors
    !this.$v.form.telefono.validTelefono && errors.push('Teléfono no válido')
    return errors
}

function telf_fijoErrores () {
    const errors = []
    if (!this.$v.form.telf_fijo.$dirty) return errors;
    ( !this.$v.form.telf_fijo.min || !this.$v.form.telf_fijo.max ) && errors.push('Número no válido')
    return errors
}

function telf_movilErrores () {
    const errors = []
    if (!this.$v.form.telf_movil.$dirty) return errors;
    ( !this.$v.form.telf_movil.min || !this.$v.form.telf_movil.max ) && errors.push('Número no válido')
    return errors
}

function emailErrores () {
    const errors = []
    if (!this.$v.form.email.$dirty) return errors;
    !this.$v.form.email.email && errors.push('Email no válido')
    return errors
}

function cupsErrores() {
    const errors = []
    if (!this.$v.form.cups.$dirty) return errors;
    (!this.$v.form.cups.max || !this.$v.form.cups.min) && errors.push('CUPS debe tener entre 20 y 22 caracteres')
    return errors
}

function direccionErrores () {
    const errors = []
    if (!this.$v.form.direccion.$dirty) return errors;
    !this.$v.form.direccion.required && errors.push('La dirección es obligatioria')
    return errors
}

function cpErrores () {
    const errors = []
    if (!this.$v.form.cp.$dirty) return errors;
    ( !this.$v.form.cp.min || !this.$v.form.cp.max ) && errors.push('Código postal no válido')
    !this.$v.form.cp.required && errors.push('El código postal es obligatiorio')
    return errors
}

function localidadErrores () {
    const errors = []
    if (!this.$v.form.localidad.$dirty) return errors;
    !this.$v.form.localidad.required && errors.push('La localidad es obligatioria')
    return errors
}

function origenBbddErrores () {
    const errors = []
    if (!this.$v.form.orig_bbdd.$dirty) return errors;
    !this.$v.form.orig_bbdd.required && errors.push('Este campo es obligatiorio')
    return errors
}


function segmentoErrores () {
    const errors = []
    if (!this.$v.form.segmento.$dirty) return errors;
    !this.$v.form.segmento.required && errors.push('Este campo es obligatiorio')
    return errors
}

function comercialErrores () {
    const errors = []
    if (!this.$v.form.comercial.$dirty) return errors;
    !this.$v.form.comercial.required && errors.push('Este campo es obligatiorio')
    return errors
}

function ispErrores () {
    const errors = []
    if (!this.$v.form.isp.$dirty) return errors;
    !this.$v.form.isp.required && errors.push('Este campo es obligatiorio')
    return errors
}

function estadoErrores () {
    const errors = []
    if (!this.$v.form.estado.$dirty) return errors;
    !this.$v.form.estado.required && errors.push('Este campo es obligatiorio')
    return errors
}

function ofertaErrores () {
    const errors = []
    if (!this.$v.form.oferta.$dirty) return errors;
    !this.$v.form.oferta.required && errors.push('Este campo es obligatiorio')
    return errors
}


export {
    nombreErrores,
    documentoErrores,
    telf_fijoErrores,
    telf_movilErrores,
    emailErrores,
    cupsErrores,
    direccionErrores,
    cpErrores,
    localidadErrores,
    origenBbddErrores,
    segmentoErrores,
    comercialErrores,
    ispErrores,
    estadoErrores,
    ofertaErrores,
    telefonoErrores,
};